import React from 'react';
import ImageCaption from './ImageCaption';
import type { DropSide } from './ImageNode';
import ImageNode from './ImageNode';

interface ImageContainerProps {
  src?: string;
  uploading?: boolean;
  caption?: string;
  onCaptionChange?: (caption: string) => void;
  width?: number;
  onDrop?: (files: File[], side: DropSide) => void;
}

const ImageContainer = ({
  src = '',
  uploading = false,
  caption,
  onCaptionChange,
  width,
  onDrop,
}: ImageContainerProps) => (
  <>
    <ImageNode
      onDrop={onDrop}
      className="image-content"
      containerClassName="image-container"
      src={src}
      uploading={uploading}
      width={width}
    />
    {onCaptionChange && (
      <ImageCaption caption={caption || ''} onCaptionChange={onCaptionChange} />
    )}
  </>
);

export default ImageContainer;
